import { createContext } from "react";
import type { AvatarSize } from "./Avatar";

/** xs 16px, sm 20px, md 24px. */
export type AvatarGroupSize = Extract<AvatarSize, "xs" | "sm" | "md">;

/**
 * The enclosing `AvatarGroup`'s size, read by each `Avatar` that has no
 * explicit `size`. `null` outside a group.
 */
export const AvatarGroupSizeContext = createContext<AvatarSize | null>(null);
